





















































































































































































































































































/* eslint-disable */
import { Component,Prop, Vue, Watch } from "vue-property-decorator";
import { EventBus } from "../event-bus";
import axios from "axios";
import { Token } from "../utils/Token";
import FileExplorer from "../components/FileExplorer.vue"
import EnDeCrypt from "../components/EnDeCrypt.vue"
import { File } from "../models/File";
import { Error } from "../utils/Error";
import { Log } from "../models/Log";
import UsbStatus from "../components/UsbStatus.vue";
import { UsbStatusModel } from "@/models/UsbStatus";



@Component({
  components: {
    FileExplorer,
    EnDeCrypt,
    UsbStatus,
  },
  filters: {
    /*transformFileType(value: number) {
      if (value==0) {return "Non Encrypted File";}
      if (value==1) {return "Directory";}
      if (value==2) {return "Symbolic Link";}
      if (value==3) {return "Encrypted";}
      return "other";
    },*/
    transformFileType2(value: number) {
      if (value==0) {return "Downloaded";}
      if (value==1) {return "Uploaded";}
      if (value==2) {return "Sent";}
      if (value==3) {return "Received";}
      if (value==4) {return "Decrypted";}
      return "other";
    },
    transformFileSize(bytes:number){
      if (bytes == 0) { return "0.00 B"; }
      const e = Math.floor(Math.log(bytes) / Math.log(1024));
      return (bytes/Math.pow(1024, e)).toFixed(2)+' '+' KMGTP'.charAt(e)+'B';
    },
    transformName(value: string) {
      if (value.length>19) {return value.substring(0,16)+"...";}
      return value;
    },
  },
  data: () => ({
        search: '',
        search2: '',
        previousName: 'File',
        headers: [
          { text: 'File Name',value: 'name',sortable: true,align: 'start'},
          { text: 'Encrypted', value: 'type',sortable: true},
          { text: 'Size', value: 'size',sortable: true },
          { text: 'Date', value: 'dateTime' ,sortable: true},
        ],
        headers2: [
          { text: 'File Name',value: 'name',sortable: true,align: 'start',width:"17%"},
          { text: 'From', value: 'from',sortable: true ,width:"14%"},
          { text: 'To', value: 'to',sortable: true ,width:"14%"},
          { text: 'Encrypted', value: 'encrypted',sortable: false ,width:"15%"},
          { text: 'Action', value: 'type' ,sortable: true,width:"14%"},
          { text: 'Date', value: 'dateTime' ,sortable: true,width:"26%"},
        ],
        numOfResults:['10','20','50','100','All',],
        show_start_date: false,
        show_end_date: false,
        loading3:false,
    }),
})

export default class Files extends Vue {
  @Prop()  value!: boolean;

  public title = "";
  public tab = "FileExplorer";
  public selected:Array<File>=[];

  public tabs = [
    { tab: "File Manager", content: "FileExplorer" },
    { tab: "EnCrypt DeCrypt", content: "EnDeCrypt" }
  ];
  public usbStatusModalFlag=false;
  public uStatus:UsbStatusModel=new UsbStatusModel;

  public files: Array<File>=[];
  public logs: Array<Log>=[];
  public targets:Array<any> = [];
  
  
  private errorModalFlag = false;
  private errorText = "";
  private errorTitle = "";
  
  public logFilters={
    target:{
      id:-1,
      label:"",
    },
    numOfRes:'50',
    start_date: null,
    end_date: null,

  }
  
  created() {
    const memtoken = localStorage.getItem("token");
    if (!memtoken) {
      console.log("getTokenWithExpiry returns null when Generate new Token");
      this.$router.push({ name: "Login" });
      return null;
    }else{
    
    //EventBus.$emit("BeginLoader",null );   

    this.title = `File Explorer`;
    this.tab = "FileExplorer";
    this.value=true;
  
    EventBus.$off('newFileAddition');
    EventBus.$off('fileRemoval');
    EventBus.$off('changeMade');
    EventBus.$off('ReloadLogs');
    EventBus.$off('selectedChanded');


    //for refresh: when at refresh sockets close and state is wipped out. So we must reinnitiate sockets
    this.$store.dispatch('createSockets');

    EventBus.$on("changeUsbStatusModal", (value: boolean,status: UsbStatusModel) => {
      this.uStatus=status;
      this.usbStatusModalFlag = value;
    });

    EventBus.$on("newFileAddition", (value: any) => {
      value.forEach((file:File)=>{
        let flag=false;
        const res=this.files.filter(el=>(el.path===file.path)?flag=true:"");
        (flag===false)?this.files.push(file):"";
        console.log("new file added",file);
    })
    });
    
    EventBus.$on("fileRemoval", (value: any) => {
      value.forEach((file:File)=>{
        this.files = this.files.filter( el => el.path !== file.path );
      })

    });

    EventBus.$on("changeMade", () => {
      this.selected=[];
      this.fetchFiles();
    });
 
    
    EventBus.$on("ReloadLogs", (value: any) => {
      //this.fetchFiles();    
        this.logsLoader()
      });
    
    let queue = Promise.resolve();
    const res=queue.then(()=>this.fetchFiles())
    .then(()=>this.logsLoader())
    .catch((error) => {console.log(error)});

   
    //EventBus.$emit("FinishLoader",null );
  }
  }

  beforeDestroy(){
      EventBus.$off('selectedChanded');
      EventBus.$off("unselected");

  }
  
  
  get show() {
    console.log("show :", this.value);
    return this.value===undefined?true:this.value;
  }
  
  public async fetchTargets() {
    const token = await Token.getTokenWithExpiry("token");
    //EventBus.$emit("BeginLoader",null );

    axios({
      method: "get",
      withCredentials: true,
      url: `${process.env.VUE_APP_BASE_URL}/targets`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json",
      },
    })
      .then((response) => {
        //EventBus.$emit("FinishLoader",null );   

        if (response.data.code == 401) {
          EventBus.$emit("LogOutEventBus", false);
        } else {
          if (response.data.code == 200) {
            this.targets = response.data.targets;
            console.log("target:",this.logFilters.target);
          }
        }
      })
      .catch((err) => {
        //EventBus.$emit("FinishLoader",null );   
        console.log("error:", err);
      });
  }

  //get /files
  public async fetchFiles() {
    console.log("Fetching Files");

    const token = await Token.getTokenWithExpiry("token");
    //console.log("token:", token);

    await axios({
      method: "get",
      withCredentials: true,
      url: `${process.env.VUE_APP_BASE_URL}/files`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json",
      },
    })
      .then((response) => {
        if (response.data.code == 401) {
          EventBus.$emit("LogOutEventBus", false);
        } else {
          console.log("response:", response);
          if (response.data.code == 200) {
            this.files = [];

            response.data.files.forEach((file: File) => {
              file = new File(
                file.name,
                file.path,
                file.size,
                file.type,
                file.dateTime,
                file.permissions,
              );

              this.files.push(file);
            });
          }
        }
      })
      .catch((err) => {
        //EventBus.$emit("FinishLoader",null );
        console.log(err);
      });
  }

  public async logsLoader(){
    console.log("Fetching Logs");
    //EventBus.$emit("BeginLoader",null );   

    const token = await Token.getTokenWithExpiry("token");
    //console.log("token:", token);
    const data={
      id: (this.logFilters.target!=null && this.logFilters.target.id!=null)?this.logFilters.target.id:-1,
      numOfRes: this.logFilters.numOfRes,
      startDate: this.logFilters.start_date==null?"":this.logFilters.start_date,
      endDate: this.logFilters.end_date==null?"":this.logFilters.end_date,
    };

    await axios({
      method: "post",
      withCredentials: true,
      url: `${process.env.VUE_APP_BASE_URL}/files/filterLogs`,
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json",
      },
    })
      .then((response) => {
        //EventBus.$emit("FinishLoader",null );   

        if (response.data.code == 401) {
          EventBus.$emit("LogOutEventBus", false);
        } else {
          console.log("response:", response.data);
          if (response.data.code == 200) {
            this.logs = [];

            response.data.logs.forEach((logL: Log) => {
              logL = new Log(
                logL.usid,    
                logL.aid,
                logL.name,
                logL.path,
                logL.size,
                logL.type,
                logL.dateTime,
                logL.encrypted,
                logL.from,
                logL.to,
              );

              this.logs.push(logL);
            });
          }
        }
      })
      .catch((err) => {
        //EventBus.$emit("FinishLoader",null );
        console.log(err);
      });
  }
  
  public navigateBack() {
    this.$router.push({ name: "DeviceListing" });
  }

  @Watch("selected")
  selectedChanded(file: any) {
    const sfile:Array<File>=file;
    let res:Array<File>=[];
    if (file!==undefined){
        res=sfile.filter(f=>this.files.filter(el=>f.name==el.name));
    }
    console.log("selectedChanded F",res);
    EventBus.$emit("selectedChanded",res );   
  }

/*
 private async fetchLogs() {
    console.log("Fetching Logs");

    const token = await Token.getTokenWithExpiry("token");
    //console.log("token:", token);

    await axios({
      method: "get",
      withCredentials: true,
      url: `${process.env.VUE_APP_BASE_URL}/files/logs`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json",
      },
    })
      .then((response) => {
        
        if (response.data.code == 401) {
          EventBus.$emit("LogOutEventBus", false);
        } else {
          console.log("response:", response);
          if (response.data.code == 200) {
            this.logs = [];

            response.data.logs.forEach((logL: Log) => {
              logL = new Log(
                logL.usid,    
                logL.aid,
              logL.name,
                logL.path,
                logL.size,
                logL.type,
                logL.dateTime,
                logL.encrypted,
                logL.from,
                logL.to,
              );

              this.logs.push(logL);
            });
          }
        }
      })
      .catch((err) => {
        //EventBus.$emit("FinishLoader",null );
        console.log(err);
      });
  }*/ 
} 
